import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/tmp/26d35be0/src/layouts/work.js"

export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={props}
             components={components}>

<MDXTag name="p" components={components}><MDXTag name="img" components={components} parentName="p" props={{"src":"/work/elements/1.png","alt":"Reaktor.com screens"}}></MDXTag>{`
The Elements of AI is a free online course for everyone interested in learning what AI is, what is possible (and not possible) with AI, and how it affects our lives – with no complicated math or programming required.
We designed and developed a simple and intuitive user flow. The course is richly illustrated throughout the six chapters, each one ending with exercises such as quizes and essays summarizing the key learning points. The project was done in collaboration with the University of Helsinki and Reaktor.`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{"href":"https://course.elementsofai.com/"}}>{`Check out the course`}</MDXTag></MDXTag>
<MDXTag name="p" components={components}><MDXTag name="img" components={components} parentName="p" props={{"src":"/work/elements/2.png","alt":"Reaktor.com screens"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/elements/3.png","alt":"Reaktor.com screens"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/elements/4.png","alt":"Reaktor.com screens"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/elements/5.png","alt":"Reaktor.com screens"}}></MDXTag></MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  